import Title from "@/components/Title";
import { ReadAuditLog } from "@/types/auditLog";
import { useTranslation } from "react-i18next";
import { NO_DATA } from "@/constants";

interface AuditLogDetailsSectionProps {
  auditLog: ReadAuditLog;
}

export const AuditLogDetailsSection = ({
  auditLog,
}: AuditLogDetailsSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-t pt-4">
      <Title level={4} className="mb-2 mt-0">
        {t("auditLogs.diff.details")}
      </Title>
      <div className="grid grid-cols-3 gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium">
            {t("auditLogs.fields.item_identifier")}
          </span>
          <span className="text-sm text-muted-foreground break-all">
            {auditLog.item_identifier || NO_DATA}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium">
            {t("auditLogs.fields.changed_by")}
          </span>
          <span className="text-sm text-muted-foreground break-all">
            {auditLog.changed_by}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium">
            {t("auditLogs.fields.table_name")}
          </span>
          <span className="text-sm text-muted-foreground break-all">
            {auditLog.table_name}
          </span>
        </div>
      </div>
    </div>
  );
};
